/**
 * 负责 Cookie 操作的类
 * @author Joey
 */
class ImaCookieManager {
  private static instance: ImaCookieManager;
  private readonly STORAGE_KEY = "MIUTA_TOKEN";
  private domain: string = "";

  private constructor() {
    this.setDomain(this.resolveDomain());
  }

  public static getInstance(): ImaCookieManager {
    if (!ImaCookieManager.instance) {
      ImaCookieManager.instance = new ImaCookieManager();
    }
    return ImaCookieManager.instance;
  }

  /**
   * 设置 Cookie
   */
  set(value: string, days: number = 365) {
    // 过期时间
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    const maxAge = days * 24 * 60 * 60;

    // 基础配置
    let cookieStr = `${this.STORAGE_KEY}=${encodeURIComponent(value)}; expires=${expires}; Max-Age=${maxAge}; path=/; SameSite=Lax`;

    // 绑定域名
    if (this.getDomain()) {
      cookieStr += `; domain=${this.getDomain()}`;
    }

    // 只有在 HTTPS 下才添加 Secure 属性
    if (window.location.protocol === 'https:') {
      cookieStr += '; Secure';
    }

    document.cookie = cookieStr;
  }

  /**
   * 获取 Cookie
   */
  get() {
    const key = `${this.STORAGE_KEY}=`;
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
      if (cookie.startsWith(key)) {
        return decodeURIComponent(cookie.substring(key.length));
      }
    }

    return "";
  }

  /**
   * 清除 Cookie
   */
  clear() {
    let cookieStr = `${this.STORAGE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

    // 绑定域名时，清理也要带上相同的 domain
    if (this.getDomain()) {
      cookieStr += `; domain=${this.getDomain()}`;
    }

    document.cookie = cookieStr;
  }

  private getDomain() {
    return this.domain;
  }

  private setDomain(domain: string) {
    this.domain = domain;
  }

  private resolveDomain() {
    // 开发环境保持原逻辑，固定使用 localhost
    if (import.meta.env.MODE === "development") {
      return "localhost";
    }

    const hostname = window.location.hostname;

    // 其他环境若运行在 localhost / IP 下，则退回 host-only cookie
    if (hostname === "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
      return "";
    }

    if (hostname.endsWith(".miuta.ai")) {
      return ".miuta.ai";
    }

    if (hostname.endsWith(".bizdesk.ai")) {
      return ".bizdesk.ai";
    }

    if (hostname.endsWith(".test.bhbapp.cn")) {
      return ".test.bhbapp.cn";
    }

    return "";
  }

}

// 创建单例实例
export const imaCookieManager = ImaCookieManager.getInstance();
